import Swiper, { Navigation, Pagination } from 'swiper';

export const initHomePageSlider = () => {
    new Swiper('.hero-slider .swiper-container', {
        modules: [Navigation, Pagination],
        autoplay: {
            delay: 5000,
        },
        speed: 400,
        loop: true,
        effect: 'fade',
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        paginationClickable: true,
        grabCursor: true,
        navigation: {
            nextEl: '.hero-slider__nav-button--next',
            prevEl: '.hero-slider__nav-button--prev',
        },
    });
};

export const initEmployeeSlider = () => {

    const swiper = new Swiper('.swiper', {
        modules: [Navigation],
        // Optional parameters
        //direction: 'vertical',
        loop: true,

        // Navigation arrows
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },

    });
};

export const initHeroSlider = () => {


};

export const initGalleryElementCarousel1 = () => {
	document.querySelectorAll('.js-gallery-element-carousel1').forEach(function (carousel) {
		new Swiper(carousel, {
            modules: [Navigation],
			speed: 400,
			slidesPerView: 1,
            navigation: {
                nextEl: carousel.parentNode.querySelector('.js-gallery-element-carousel1-next'),
                prevEl: carousel.parentNode.querySelector('.js-gallery-element-carousel1-prev'),
            }
		});
	});
};

export const initGalleryElementCarousel2 = () => {
	document.querySelectorAll('.js-gallery-element-carousel2').forEach(function (carousel) {
		new Swiper(carousel, {
            modules: [Navigation],
			speed: 400,
			spaceBetween: 8,
			slidesPerView: 2,
            navigation: {
                nextEl: carousel.parentNode.querySelector('.js-gallery-element-carousel2-next'),
                prevEl: carousel.parentNode.querySelector('.js-gallery-element-carousel2-prev'),
            },
			breakpoints: {
				639: {
					slidesPerView: 3
				},
				1023: {
					slidesPerView: 4
				}
			}
		});
	});
};

export const initShortcutSlider = () => {
    document.querySelectorAll('.js-shortcut-slider').forEach(function (carousel) {
        new Swiper(carousel, {
            modules: [Navigation],
            spaceBetween: 32,
            loop: true,
            slidesPerView: 1.5,
            centeredSlides: true,
            breakpoints: {
                639: {
                    slidesPerView: 2
                },
                1023: {
                    slidesPerView: 3
                },
                1500: {
                    slidesPerView: 4
                }
            },
            navigation: {
                nextEl: '.shortcut-slider__nav-button--next',
                prevEl: '.shortcut-slider__nav-button--prev',
            },
        });
    });
};


export const initInstagramCarousel = () => {
    document.querySelectorAll('.js-insta-gallery').forEach(function (carousel) {
        new Swiper(carousel, {
            speed: 400,
            spaceBetween: 8,
            slidesPerView: 2.5,
            breakpoints: {
                639: {
                    slidesPerView: 3.5
                },
                1023: {
                    slidesPerView: 4.5
                }
            }
        });
    });
};

export const initProductSlider = () => {
    let ProductSlider = new Swiper('.js-product-slider', {
        speed: 400,
    });

    let paginationItems = document.querySelectorAll('.js-product-slider-pagination-item');

    paginationItems.forEach(item => {
        item.addEventListener('click', function() {
            let index = this.dataset.index - 1;
            ProductSlider.slideTo(index);
        });
    });
}
